// extracted by mini-css-extract-plugin
module.exports = {"layout-root":"PageLayout_layout-root__FslDW","layout-row":"PageLayout_layout-row__3jGem","constrain":"PageLayout_constrain__ykrk3"};